type SessionExpiredHandler = () => void;

let handler: SessionExpiredHandler | null = null;

/**
 * How the Apollo link chain, which knows nothing about React, tells the app
 * that the API has stopped accepting the token.
 *
 * The alternative -- `window.location.assign('/login')` from inside the link --
 * reloads the whole bundle and loses the notification on the way, so the
 * navigation is left to the router and only the hand-off lives here.
 */
export function onSessionExpired(next: SessionExpiredHandler): () => void {
  handler = next;

  return () => {
    if (handler === next) handler = null;
  };
}

export function sessionExpired(): void {
  if (handler) {
    handler();
    return;
  }

  // Nothing mounted yet (an `adminMe` that lost its race with the first paint,
  // say). A hard navigation is the only thing left, and it is correct.
  window.location.assign('/login');
}
